import $ from "jquery";

export function mobilemenu() {
	$(".js-menu").on("click", function () {
		$("body").toggleClass("menuopen");
		$("body").toggleClass("opensidemenu");
		$(".js-mobilemenu").toggleClass("open");
	});

	$(".js-oplossingen").on("click", function (e) {
		e.stopPropagation();
		if ($("#subheader_oplossingen").hasClass("show")) {
			$("#subheader_oplossingen, .subheader").removeClass("show");
			$(this).removeClass("active");
		} else if ($("#subheader_bedrijf").hasClass("show") || $("#subheader_producten").hasClass("show")) {
			$(".onderdeel").removeClass("show");
			$("#subheader_oplossingen").addClass("show");
			$(".js-bedrijf, .js-producten").removeClass("active");
			$(this).addClass("active");
		} else {
			$(".onderdeel, .subheader").removeClass("show");
			$("#subheader_oplossingen, .subheader").addClass("show");
			$(this).addClass("active");
		}
	});

	$(".js-bedrijf").on("click", function (e) {
		e.stopPropagation();
		if ($("#subheader_bedrijf").hasClass("show")) {
			$("#subheader_bedrijf, .subheader").removeClass("show");
			$(this).removeClass("active");
		} else if ($("#subheader_oplossingen").hasClass("show") || $("#subheader_producten").hasClass("show")) {
			$(".onderdeel").removeClass("show");
			$("#subheader_bedrijf").addClass("show");
			$(".js-oplossingen, .js-producten").removeClass("active");
			$(this).addClass("active");
		} else {
			$(".onderdeel, .subheader").removeClass("show");
			$("#subheader_bedrijf, .subheader").addClass("show");
			$(this).addClass("active");
		}
	});

	$(".js-producten").on("click", function (e) {
		e.stopPropagation();
		if ($("#subheader_producten").hasClass("show")) {
			$("#subheader_producten, .subheader").removeClass("show");
			$(this).removeClass("active");
		} else if ($("#subheader_oplossingen").hasClass("show") || $("#subheader_bedrijf").hasClass("show")) {
			$(".onderdeel").removeClass("show");
			$("#subheader_producten").addClass("show");
			$(".js-oplossingen, .js-bedrijf").removeClass("active");
			$(this).addClass("active");
		} else {
			$(".onderdeel, .subheader").removeClass("show");
			$("#subheader_producten, .subheader").addClass("show");
			$(this).addClass("active");
		}
	});

	$(document).on("click", function () {
		$(".onderdeel, .subheader").removeClass("show");
		$(".js-oplossingen, .js-bedrijf, .js-producten").removeClass("active");
	});

	$("body").on("click", function () {
		if ($("#mobile-menu").hasClass("show")) {
			$("#mobile-menu").removeClass("show").addClass("hide");
		}
	});

	$("#mobile-menu").on("click", function (e) {
		e.stopPropagation();
	});

	$(".js-menu").on("click", function (e) {
		e.stopPropagation();
		$("#mobile-menu").toggleClass("hide show");
	});
	
	$("#mobile-menu-producten").on("click", function () {
		$("#mobile-menu-screen-producten").removeClass("hide").addClass("show");
		$("#mobile-menu-main").removeClass("show");
	});
	
	$("#mobile-menu-diensten").on("click", function () {
		$("#mobile-menu-screen-diensten").removeClass("hide").addClass("show");
		$("#mobile-menu-main").removeClass("show");
	});

	$("#mobile-menu-sectoren").on("click", function () {
		$("#mobile-menu-screen-sectoren").removeClass("hide").addClass("show");
		$("#mobile-menu-main").removeClass("show");
	});

	$("#mobile-menu-bedrijf").on("click", function () {
		$("#mobile-menu-screen-bedrijf").removeClass("hide").addClass("show");
		$("#mobile-menu-main").removeClass("show");
	});

	$(".backbutton").on("click", function (e) {
		e.preventDefault();
		$(this).closest(".screen").removeClass("show").addClass("hide");
		$("#mobile-menu-main").removeClass("hide").addClass("show");
	});
}